import '../../style/';
import './index.less';



// WEBPACK FOOTER //
// ./components/swipe-action/style/index.tsx